// extracted by mini-css-extract-plugin
export default {"wrapper":"NewsletterConfirmation-module--wrapper--2ryao","icon":"NewsletterConfirmation-module--icon--2B8Ys","fadeFromBottom":"NewsletterConfirmation-module--fadeFromBottom--3qaEd"};